// extracted by mini-css-extract-plugin
export default {"container":"addNewPanel_container__3C2RB"};